import { XIcon } from '@phosphor-icons/react';
import React, { useState, useEffect } from 'react';

// Danh sách Server dành cho nền tảng MT4
const MT4_SERVERS = [
    'ECMarkets-Demo',
    'ECMarkets-Live01',
    'ECMarkets-Live02',
    'ECMarkets-Live03',
    'ECMarkets-Live04',
    'ECMarkets-Live05',
    'ECMarkets-Live06',
    'ECMarkets-Live07',
    'ECMarkets-Live08',
    'ECMarkets-Live09',
    'ECMarkets-Live10',
    'ECMarkets-Live11',
    'ECMarkets-Live12',
    'ECMarkets-Live13',
    'ECMarketsLtd-Demo02',
    'ECMarketsGroupLtd-Demo',
    'ECMarketsGroupLtd-Live01',
    'FTMO-Demo2',
    'FTMO-Server',
    'FTMO-Server2',
    'FTMO-Server3',
    'FTMO-Server4',
    'ICMENA-MT4',
    'ICMarkets-Demo01',
    'ICMarkets-Demo02',
    'ICMarkets-Demo03',
    'ICMarkets-Demo04',
    'ICMarkets-Live01',
    'ICMarkets-Live02',
    'ICMarkets-Live03',
    'ICMarkets-Live04',
    'ICMarkets-Live05',
    'ICMarkets-Live06',
    'ICMarkets-Live07',
    'ICMarkets-Live08',
    'ICMarkets-Live09',
    'ICMarkets-Live10',
    'ICMarkets-Live11',
    'ICMarkets-Live12',
    'ICMarkets-Live14',
    'ICMarkets-Live15',
    'ICMarkets-Live16',
    'ICMarkets-Live17',
    'ICMarkets-Live18',
    'ICMarkets-Live19',
    'ICMarkets-Live20',
    'ICMarkets-Live22',
    'ICMarkets-Live23',
    'ICMarkets-Live24',
    'ICMarketsAU-MT4-Demo',
    'ICMarketsAU-MT4-Live',
    'ICMarketsEU-Demo01',
    'ICMarketsEU-Demo02',
    'ICMarketsEU-Demo03',
    'ICMarketsEU-Live28',
    'ICMarketsGRP-Demo01',
    'ICMarketsGRP-Live01',
    'ICMarketsGRP-Live35',
    'ICMarketsInternational-Demo05',
    'ICMarketsInternational-Live29',
    'ICMarketsKE-Demo05',
    'ICMarketsKE-Live35',
    'ICMarketsSC-Demo01',
    'ICMarketsSC-Demo02',
    'ICMarketsSC-Demo03',
    'ICMarketsSC-Demo04',
    'ICMarketsSC-Demo06',
    'ICMarketsSC-Live01',
    'ICMarketsSC-Live02',
    'ICMarketsSC-Live03',
    'ICMarketsSC-Live04',
    'ICMarketsSC-Live05',
    'ICMarketsSC-Live06',
    'ICMarketsSC-Live07',
    'ICMarketsSC-Live08',
    'ICMarketsSC-Live09',
    'ICMarketsSC-Live10',
    'ICMarketsSC-Live11',
    'ICMarketsSC-Live12',
    'ICMarketsSC-Live14',
    'ICMarketsSC-Live15',
    'ICMarketsSC-Live16',
    'ICMarketsSC-Live17',
    'ICMarketsSC-Live18',
    'ICMarketsSC-Live19',
    'ICMarketsSC-Live20',
    'ICMarketsSC-Live21',
    'ICMarketsSC-Live22',
    'ICMarketsSC-Live23',
    'ICMarketsSC-Live24',
    'ICMarketsSC-Live25',
    'ICMarketsSC-Live26',
    'ICMarketsSC-Live27',
    'ICMarketsSC-Live31',
    'ICMarketsSC-Live32',
    'ICMarketsSC-Live33',
    'ICMarketsSC-Live34',
    'MetaQuotes-Demo',
    'ThinkMarkets-Demo',
    'ThinkMarkets-Live',
    'ThinkMarkets-Live2',
    'ThinkMarkets-Live4'
];

// Danh sách Server dành cho nền tảng MT5
const MT5_SERVERS = [
    'AtmosGlobal-LIVE',
    'ECMarketsLtd-Demo',
    'ECMarketsLtd-MT5-Live02',
    'ECMarketsLtd-MT5-Live03',
    'ECMarkets-MT5-Live01',
    'ECMarketsNZ-MT5-Live04',
    'FTMO-Demo',
    'FTMO-Demo2',
    'FTMO-Server',
    'FTMO-Server2',
    'FTMO-Server3',
    'FTMO-Server4',
    'FTMO-Server5',
    'MetaQuotes-Demo',
    'ICMarketsEU-Demo',
    'ICMarketsEU-MT5-5',
    'ICMarketsKE-Demo',
    'ICMarketsKE-MT5-7',
    'ICMarketsGRP-Demo',
    'ICMarketsGRP-MT5',
    'ICMarketsInternational-Demo',
    'ICMarketsInternational-MT5-4',
    'ICMarketsInternational-MT5-2',
    'ICMarketsInternational-MT5',
    'ICMarkets-Demo',
    'ICMarkets-MT5',
    'ICMarkets-MT5-2',
    'ICMarkets-MT5-4',
    'ICMarketsAU-Demo',
    'ICMarketsAU-Live'
];

// Định nghĩa giao diện dữ liệu đầu ra khi submit
export interface BotCreateParams {
    account_number: string;
    platform: string;
    ctrader_id?: string;
    password?: string;
    server_name?: string;
}

// Props cho Component BotCreateModal
export interface BotCreateModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: BotCreateParams) => Promise<void> | void;
    account_number?: string;
    platform?: string;
}

export const BotCreateModal: React.FC<BotCreateModalProps> = ({
    isOpen,
    onClose,
    onSubmit,
    account_number = '',
    platform = 'ctrader',
}) => {
    // State lưu trữ dữ liệu form
    const [account, setAccount] = useState<string>(account_number);
    const [currentPlatform, setCurrentPlatform] = useState<string>(platform || 'ctrader');
    const [ctraderId, setCtraderId] = useState<string>('');
    const [serverName, setServerName] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    // State ẩn / hiện mật khẩu & trạng thái loading khi submit
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    useEffect(() => {
        if (isOpen) {
            setAccount(account_number || '');
            setCurrentPlatform(platform || 'ctrader');
            setCtraderId('');
            setServerName('');
            setPassword('');
            setShowPassword(false);
            setIsSubmitting(false);
        }
    }, [isOpen, account_number, platform]);

    if (!isOpen) return null;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            setIsSubmitting(true);
            await onSubmit({
                account_number: account,
                platform: currentPlatform.toLowerCase(),
                ctrader_id: ctraderId,
                server_name: serverName,
                password: password,
            });
            onClose();
        } catch (error) {
            console.error('Lỗi khi gửi thông tin kết nối Bot:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Kiểm tra có phải nền tảng cTrader hay không
    const isCtrader = currentPlatform.toLowerCase().includes('ctrader');

    // Xác định danh sách Server tương ứng với platform chọn
    const serverOptions = currentPlatform.toLowerCase().includes('mt5') ? MT5_SERVERS : MT4_SERVERS;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
            {/* Modal Card */}
            <div className="w-full max-w-[620px] bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-700/20 transform transition-all">
                <div className="bg-[#0b1928] px-7 py-6 relative text-white">
                    {/* Nút Đóng Modal (X) */}
                    <button
                        type="button"
                        onClick={onClose}
                        className="absolute top-5 right-6 text-slate-400 hover:text-white transition-colors duration-200 text-xl font-semibold leading-none p-1"
                        aria-label="Đóng modal"
                    >
                        <XIcon size={20} />
                    </button>
                    <h2 className="!text-xl font-bold text-white tracking-tight">
                        Kết nối tài khoản giao dịch
                    </h2>
                    <p className="!text-[13.5px] !text-[#8ca0ba] !my-0 font-normal">
                        Nhập thông tin để liên kết tài khoản của bạn
                    </p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="p-7 bg-white">

                        {/* 2-column Grid with aligned heights */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-5 items-start">

                            {/* Field 1: Account Number */}
                            <div className="flex flex-col space-y-2">
                                <label className="block text-[13.5px] font-semibold text-[#8ca0ba] h-[20px] leading-[20px]">
                                    Tài khoản
                                </label>
                                <input
                                    type="text"
                                    value={account}
                                    onChange={(e) => setAccount(e.target.value)}
                                    placeholder="Nhập số tài khoản"
                                    className="w-full h-12 px-4 bg-[#f5f7f9] border border-[#e1e7ec] rounded-xl text-[15px] font-semibold text-slate-700 placeholder-slate-400 focus:outline-none focus:border-[#00be8a] focus:ring-2 focus:ring-[#00be8a]/20 transition-all box-border"
                                    required
                                />
                            </div>

                            {/* Field 2: Platform */}
                            <div className="flex flex-col space-y-2">
                                <label className="block text-[13.5px] font-semibold text-[#8ca0ba] h-[20px] leading-[20px]">
                                    Nền tảng
                                </label>
                                <input
                                    type="text"
                                    value={`#${currentPlatform.toUpperCase()}`}
                                    readOnly
                                    className="w-full h-12 px-4 bg-[#f5f7f9] border border-[#e1e7ec] rounded-xl text-[15px] font-bold text-[#00be8a] uppercase cursor-default select-none focus:outline-none box-border"
                                />
                            </div>

                            {/* Field 3: cTrader ID or Server Name Select */}
                            {isCtrader ? (
                                <div className="flex flex-col space-y-2">
                                    <label className="block text-[13.5px] font-semibold text-[#8ca0ba] h-[20px] leading-[20px] truncate">
                                        cTrader ID (Email Ctrader)
                                    </label>
                                    <input
                                        type="text"
                                        value={ctraderId}
                                        onChange={(e) => setCtraderId(e.target.value)}
                                        placeholder="Nhập CID (Tài khoản mail ctra..."
                                        className="w-full h-12 px-4 bg-[#f5f7f9] border border-[#e1e7ec] rounded-xl text-[15px] font-medium text-slate-700 placeholder-slate-400 focus:outline-none focus:border-[#00be8a] focus:ring-2 focus:ring-[#00be8a]/20 transition-all box-border"
                                        required
                                    />
                                </div>
                            ) : (
                                <div className="flex flex-col space-y-2">
                                    <label className="block text-[13.5px] font-semibold text-[#8ca0ba] h-[20px] leading-[20px]">
                                        Tên Server
                                    </label>
                                    <select
                                        value={serverName}
                                        onChange={(e) => setServerName(e.target.value)}
                                        className="w-full h-12 px-4 bg-[#f5f7f9] border border-[#e1e7ec] rounded-xl text-[15px] font-medium text-slate-700 focus:outline-none focus:border-[#00be8a] focus:ring-2 focus:ring-[#00be8a]/20 transition-all box-border cursor-pointer"
                                        required
                                    >
                                        <option value="" disabled>-- Chọn Server --</option>
                                        {serverOptions.map((server) => (
                                            <option key={server} value={server}>
                                                {server}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {/* Field 4: Password with toggle */}
                            <div className="flex flex-col space-y-2">
                                <label className="block text-[13.5px] font-semibold text-[#8ca0ba] h-[20px] leading-[20px]">
                                    Mật khẩu
                                </label>
                                <div className="relative w-full h-12">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Nhập mật khẩu"
                                        className="w-full h-full px-4 pr-11 bg-[#f5f7f9] border border-[#e1e7ec] rounded-xl text-[15px] font-medium text-slate-700 placeholder-slate-400 focus:outline-none focus:border-[#00be8a] focus:ring-2 focus:ring-[#00be8a]/20 transition-all box-border"
                                        required
                                    />
                                    {/* Căn chỉnh lại vị trí nút hiện/ẩn mật khẩu bằng flex & inset-y-0 */}
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-500 hover:text-slate-800 focus:outline-none transition-colors"
                                        aria-label="Hiện/Ẩn mật khẩu"
                                    >
                                        {showPassword ? (
                                            <svg className="w-5 h-5 stroke-current" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858-5.908a8.962 8.962 0 012.122-.063c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 3l18 18" />
                                            </svg>
                                        ) : (
                                            <svg className="w-5 h-5 stroke-current" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>

                    {/* Footer */}
                    <div className="bg-[#f8fafc] px-7 py-4 border-t border-slate-100 flex items-center justify-end !space-x-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-6 py-2.5 rounded-xl border border-slate-300 text-slate-800 font-semibold text-[15px] bg-white hover:bg-slate-50 active:bg-slate-100 transition-colors duration-150"
                        >
                            Hủy
                        </button>
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="px-7 py-2.5 rounded-xl bg-[#00be8a] hover:bg-[#00a87a] text-white font-semibold text-[15px] shadow-sm hover:shadow active:scale-[0.99] transition-all duration-150 flex items-center justify-center min-w-[100px]"
                        >
                            {isSubmitting ? (
                                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                'Kết nối'
                            )}
                        </button>
                    </div>
                </form>

            </div>
        </div>
    );
};

export default BotCreateModal;